import { render, staticRenderFns } from "./HoldingNoUpdate_2.vue?vue&type=template&id=2bbc543e&scoped=true&"
import script from "./HoldingNoUpdate_2.vue?vue&type=script&lang=js&"
export * from "./HoldingNoUpdate_2.vue?vue&type=script&lang=js&"
import style0 from "./HoldingNoUpdate_2.vue?vue&type=style&index=0&id=2bbc543e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc543e",
  null
  
)

export default component.exports